import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Configuracao } from '../../../core/models/configuracoes/configuracao';
import { PedidoItens } from '../../../core/models/pedidos/pedido-itens';
import { ProdutoPromocional } from '../../../core/models/produtos/produto-promocional';

/** Consulta dos itens. Cálculos e permissões são fornecidos pelo pedido; edição ocorre no modal de inclusão. */
@Component({
  selector: 'app-pedido-itens-tabela',
  standalone: false,
  templateUrl: './pedido-itens-tabela.component.html',
  styleUrls: ['./pedido-itens-tabela.component.scss']
})
export class PedidoItensTabelaComponent {
  @Input() pedidoAprovarExterno = false;
  @Input() calculando = false;
  @Output() itemEditado = new EventEmitter<{ id_produto: number; id_campanha: number }>();
  @Output() itemExcluido = new EventEmitter<{ indice: number; id_produto: number; id_campanha: number }>();
  readonly itensExpandidos = new WeakSet<ProdutoPromocional>();

  alternarDetalhes(produto: ProdutoPromocional): void {
    if (this.itensExpandidos.has(produto)) this.itensExpandidos.delete(produto);
    else this.itensExpandidos.add(produto);
  }

  get totalColunas(): number {
    return 5 + Number(this.podeExibirMargemItemPedido) + Number(this.exibirPontuacao) + Number(!this.pedidoAprovarExterno);
  }
  @Input() configuracao: Configuracao = null;
  @Input() produtosAdicionados: ProdutoPromocional[] = [];
  @Input() pedidoItensInativos: PedidoItens[] = [];

  @Input() fatorFinanceiroAtivo = false;
  @Input() podeExibirMargemItemPedido = false;
  @Input() exibirPontuacao = false;
  @Input() exibirFatorFinanceiro = false;

  @Input() calcularMargemItemPedido: (produto: ProdutoPromocional) => number = () => 0;
  @Input() valorSemFatorItem: (produto: ProdutoPromocional) => number = () => 0;
  @Input() valorFatorItem: (produto: ProdutoPromocional) => number | null = (produto) => produto?.valor_fator_financeiro_unitario ?? null;
  @Input() formatarValoresQuatroCasasDecimais: (valor: number, porcentagem?: boolean, zero?: boolean) => string = () => '';

}
